import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
// import {SESSION_DATA, user,} from "../../constants";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { currentIp } from "../../constants";
import { FaArrowDown, FaArrowRight } from "react-icons/fa";
import Checkbox from "react-custom-checkbox";
import paramarshLogo from "../../../assets/paramarshLogo.png";
import { WiSleet, WiSunrise, WiSunset } from "react-icons/wi";
import { PiClockAfternoonThin } from "react-icons/pi";
import { MdOutlineNightlight } from "react-icons/md";
import { BsCalendarDateFill } from "react-icons/bs";
import { IoIosArrowBack } from "react-icons/io";
import Moment from "moment";
import { extendMoment } from "moment-range";

const ExpertAvailability = () => {
  const navigate = useNavigate();
  const moment = extendMoment(Moment);
  const curDate = moment().format("YYYY-MM-DD");
  const tomorrow = moment().add(1, 'day').format("YYYY-MM-DD");
  

  const { id } = useParams();
  console.log("test expert",id)
  const { SESSION_DATA, user } = useSelector((state) => state.user);

  const [shiftFlag, setShiftFlag] = useState("Morning Shift");
  const [addUpdate, setAddUpdate] = useState(false);
  const [currentSlot, setCurrentSlot] = useState("morningSlot");
  const [expAvailRespData, setExpAvailRespData] = useState([]);
  const [expAvailDateIdMap, setExpAvailDateIdMap] = useState([]);
  const [expSlotOnlineOfflineData, setExpSlotOnlineOfflineData] = useState([]);
  const [locationFlag, setLocationFlag] = useState(false);
      const [stateDistInfo, setStateDistInfo] = useState([]);
      const [currState, setCurrState] = useState({});
      const [districtData, setDistrictData] = useState([]);
      const [currDistrict, setCurrDistrict] = useState({});
      const [locationNotiFlag, setLocationNotiFlag] = useState(false);

  
  const [stateDistData, errorStateDist, loadingStateDist, axiosFetchStateDist] =
  useAxios();


  const FETCH_SHIFT_URL = "master/getShiftData";
  // const FETCH_LOC_URL = "master/getLocationData";
  const GET_STATE_DIST_URL = `master/getStateDistrictData`;


  const getStateData = (url) => {
    axiosFetchStateDist({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };

     useEffect(() => {
        getStateData(GET_STATE_DIST_URL);   
    },[GET_STATE_DIST_URL]);

    useEffect(() => {
      setStateDistInfo(stateDistData?.[0]?.StateDistrictsData) 
  },[loadingStateDist]);

  const handleClick = (getShift) => {
    setShiftFlag(getShift);
    if (getShift == "Morning Shift") {
      setCurrentSlot("morningSlot");
    }
    if (getShift == "Afternoon Shift") {
      setCurrentSlot("afternoonSlot");
    }
    if (getShift == "Evening Shift") {
      setCurrentSlot("eveningSlot");
    }
    if (getShift == "Night Shift") {
      setCurrentSlot("nightSlot");
    }
  };
  const [shiftData, errorShift, loadingShift, axiosFetchShift] = useAxios();
  const [ExpAvailResp, errorAvail, loadingAvail, axiosSubmitAvail] = useAxios();
  const [locationData, errorLocation, loadingLocation, axiosLocation] = useAxios();
  const [dateResData, errorSubmit, loadingSubmit, axiosSubmit] = useAxios();
  const [
    repSlotStatus,
    errorUpdateSlotStatus,
    loadingUpdateSlotStatus,
    axiosUpdateSlotStatus,
  ] = useAxios();
  const [
    repAllSlotStatus,
    errorAllSlotStatus,
    loadingAllSlotStatus,
    axiosUpdateAllSlotStatus,
  ] = useAxios();

  const SUBMIT_EXP_AVAIL_URL = "expert/getExpAvalSlots";
  const SUBMIT_SLOT_STATUS_URL = "expert/updateExpAvalSlots";
  const ALL_SLOT_URL = "expert/putAllExpAvalSlots";

  const form = useForm({
    defaultValues: {
      mode: "offline",
      slotStartDate: curDate,
      slotEndDate: tomorrow,
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;


  const getShiftData = (url) => {
    axiosFetchShift({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
  const getSlotData = (url) => {
    axiosSubmit({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
  const getLocationData = (url) => {
    axiosLocation({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

  useEffect(() => {
    getShiftData(FETCH_SHIFT_URL);
  }, [FETCH_SHIFT_URL]);
  
  // useEffect(() => {
  //   getLocationData(FETCH_LOC_URL);
  // }, [FETCH_LOC_URL]);

  const getDateRange = (firstDate, lastDate) => {
    if (
      moment(firstDate, "YYYY-MM-DD").isSame(
        moment(lastDate, "YYYY-MM-DD"),
        "day"
      )
    )
      return [lastDate];
    let date = firstDate;
    const dates = [date];
    do {
      date = moment(date).add(1, "day");
      dates.push(date.format("YYYY-MM-DD"));
    } while (moment(date).isBefore(lastDate));
    return dates;
  };
  
  const handleSlotAllStatus = async (
    objId,
    getAllCheckedFlag,
    getShiftAll,
    getExpModeId
   
  ) => {
    const dataSlot =  {
      objId: objId,
      getShift: getShiftAll,
      slotStatus: getAllCheckedFlag == "true"?"V":"A",
      expertModeId: getExpModeId

    }
    await axiosUpdateAllSlotStatus({
      axiosInstance: axiosInstance,
      url: ALL_SLOT_URL,
      method: "POST",
      requestConfig: {
        data: dataSlot,
      },
    });
    submitFormModal();

  };
  



  const handleSlotStatus = async (
    getObjId,
    getSlotName,
    getSlotId,
    getCurrStatus,
    getExpModeId
    
   
  ) => {
    // if (getCurrStatus!== "B" && user?.usertype !== "admin") { // A: available, B: booked, V: vacant

      // Filter by desired date
// const matchingIds = expAvailRespData
//   .filter(slot => slot.slotDate === getSlotDate)
//   .map(slot => slot._id);
// console.log("matchingIds",matchingIds);
// const matchingId =  matchingIds.length > 0 ? matchingIds[0] : "";
// const matchingId =  expAvailDateIdMap?.[getSlotDate] || "";
     
      const expStatusUpdateData = {
        dateObjId: getObjId,
        slotName: getSlotName,
        slotId: getSlotId,
        currStatus: getCurrStatus == "A" ? "V" : getCurrStatus == "V" ? "A" : getCurrStatus == "B" ? "A":"V",
        expModeId: getCurrStatus == "A" ? "" : getCurrStatus == "V" ? getExpModeId : getCurrStatus == "B" ? getExpModeId : "",
      };
      await axiosUpdateSlotStatus({
        axiosInstance: axiosInstance,
        url: SUBMIT_SLOT_STATUS_URL,
        method: "POST",
        requestConfig: {
          data: expStatusUpdateData,
        },
      });
      submitFormModal();
    // }
  };

  // useEffect(() =>{
  //   submitFormModal();
  //   setExpAvailRespData(ExpAvailResp);
  // },[loadingUpdateSlotStatus])

  function submitFormModal() {
    handleSubmit(onFormSubmit)();
    
  }

  const onFormSubmit = async (data) => {
    const slotDates = getDateRange(data.slotStartDate, data.slotEndDate);
   const locationId = data.mode === "offline"?data.location.split("_")[0]:"";
   const locationName = data.mode === "offline"?data.location.split("_")[1]:"";
console.log("user",user)
    let formData = {
      mode:data.mode,
      locationId:locationId,
      locationName:locationName,
      slotStartDate: data.slotStartDate,
      slotEndDate: data.slotEndDate,
      slotArray: slotDates,
      expertId: user?.usertype == "admin" ? id : user?._id,
      morningSlot: [
        {
          status: "V",
          time: "7:00 AM",
          expertModeId: ""
        },
        {
          status: "V",
          time: "7:15 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "7:30 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "7:45 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:00 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:15 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:30 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:45 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:00 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:15 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:30 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:45 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "10:00 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "10:15 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "10:30 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "10:45 AM",
          expertModeId: ""

        },
        // {
        //   status: "V",
        //   time: "00:00",
        //   expertModeId: ""

        // },
      ],
      afternoonSlot: [
        {
          status: "V",
          time: "11:00 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "11:15 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "11:30 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "11:45 AM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "12:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "12:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "12:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "12:45 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "01:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "1:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "1:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "1:45 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "2:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "2:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "2:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "2:45 PM",
          expertModeId: ""

        },
        // {
        //   status: "V",
        //   time: "00:00",
        //   expertModeId: ""

        // },
      ],
      eveningSlot: [
        {
          status: "V",
          time: "3:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "3:15 PM",          
          expertModeId: ""

        },
        {
          status: "V",
          time: "3:30 PM",         
           expertModeId: ""

        },
        {
          status: "V",
          time: "3:45 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "4:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "4:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "4:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "4:45 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "5:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "5:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "5:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "5:45 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "6:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "6:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "6:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "6:45 PM",
          expertModeId: ""

        },
        // {
        //   status: "V",
        //   time: "00:00",
        //   expertModeId: ""

        // },
      ],
      nightSlot: [
        {
          status: "V",
          time: "7:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "7:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "7:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "7:45 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "8:45 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:00 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:15 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:30 PM",
          expertModeId: ""

        },
        {
          status: "V",
          time: "9:45 PM",
          expertModeId: ""

        },
        // {
        //   status: "V",
        //   time: "00:00",
        //   expertModeId: ""

        // },
      ],
    };
console.log("formData",formData)

    await axiosSubmitAvail({
      axiosInstance: axiosInstance,
      url: SUBMIT_EXP_AVAIL_URL,
      method: "POST",
      requestConfig: {
        data: formData,
      },
    });

    setAddUpdate(true);
  };

  useEffect(() => {
    if (errorAvail) {
      toast.error(`Update Error Found!!error:${errorAvail}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 50,
      });
      setAddUpdate(false);
    } else if (addUpdate) {
      toast.info("Slot Updated", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 500,

      });
      setAddUpdate(false);
    }
  }, [loadingAvail,errorAvail]);

  useEffect(() => {
    setExpAvailRespData(ExpAvailResp?.[0]?.expSlotData || []);
    setExpSlotOnlineOfflineData(ExpAvailResp?.[0]?.expOnOffSlotData || []);
    let dateIdMap = {};

    if (ExpAvailResp?.[0]?.expSlotData?.length > 0) {
      ExpAvailResp[0].expSlotData.forEach((slot) => {
        if (slot.slotDate && slot._id) {
          dateIdMap[slot.slotDate] = slot._id;
        }
      });
    }
    setExpAvailDateIdMap(dateIdMap || []);

  }, [loadingAvail,errorAvail]);


  const handleDistrict = (e) => {
    resetField("district");
    resetField("location");
    setLocationFlag(false);
    const [stateId, stateName] = e.target.value.split("_");  
    const filteredDistricts = stateDistInfo?.find(
      (item) => item._id === stateId
    )?.districts;  
    if (filteredDistricts) {
      const districtOptions = filteredDistricts?.map((district) => ({
        id: district?._id,
        districtName: district?.districtName,
      }));
      setDistrictData( districtOptions);
      setCurrState(prev => ({
        ...prev,
        stateId,
        stateName
      }));
          } else {
        setDistrictData([]);
        setCurrState({});
    }
  };
  const handleLocation = (e) => {
    setExpSlotOnlineOfflineData([]);  
    setExpAvailDateIdMap([]);  
    resetField("location");
      const selectedMode = e.target.value;
      const [districtId, districtName] = e.target.value.split("_");  
  
      // if (selectedMode === "offline") {
      //   setLocationFlag(true)
      // } else if (selectedMode === "online") {
      //   setLocationFlag(false)
      // } else {
      //   setLocationFlag(false)
      // }
      if (selectedMode) {
        setLocationFlag(true);

        setCurrDistrict(prev => ({
          ...prev,
          districtId,
          districtName
        }));
       
        getLocationData(`master/getLocationDataByStateDistrict/${currState?.stateId}/${districtId}`);
        setLocationNotiFlag(true);
      }  else {
        setLocationFlag(false);
        setLocationNotiFlag(false);

      }
    }

useEffect(() =>{
  if(locationNotiFlag && locationData?.[0]?.success){
    toast.success(locationData?.[0]?.message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 500,
    })

  }else if(locationNotiFlag && !locationData?.[0]?.success){
    toast.error(locationData?.[0]?.message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 500,
    })

  }
  setLocationNotiFlag(true);

},[locationData])

  return (
    <>
      <div className="card min-height-100">
        <div className="card-title flex-row">
          <h2 className="text-navyBlue"> Slot Availability </h2>
          {user?.usertype == "expert" ? (
            <></>
          ) : (
            <>
              <Link to="/expert/expertlisting">
                <button className="btn btn-blue rounded-10">
                  <IoIosArrowBack />
                </button>
              </Link>
            </>
          )}
        </div>


        <ToastContainer />
       

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
              {/* <div className="col-md-3 ">
              <label htmlFor="mode" className="text-gray text-semi-bold">
                   Mode <span className="text-red">*</span>
                </label>
              <select
                  id="mode"
                  {...register("mode", {
                    required: {
                      value: true,
                      message: "Mode field is Required",
                    },
                  })}
                  type="text"
                  className="form-control"
                  placeholder="Select mode"
                  onChange={(e) => handleLocation(e)}
                >
                  <option value="">Select mode</option>
                  <option value="online">Online Mode</option>
                  <option value="offline">Offline Mode</option>
                  
                </select>
                <p className="text-red">{errors.mode?.message}</p>
              </div> */}
              <input
                  id="mode"
                  {...register("mode", {
                    required: {
                      value: true,
                      message: "Mode Field is Required",
                    },
                  })}
                  type="hidden"
                  className="form-control rounded-10 mb-15"
                />
              <div className="col-md-3 ">
              <label htmlFor="state" className="text-gray text-semi-bold">
              State <span className="text-red">*</span>
                </label>
              <select
                  id="state"
                  {...register("state", {
                    required: {
                      value: true,
                      message: "State field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select State"
                  onChange={handleDistrict}

                >
                  <option value="">Select State</option>
                  {stateDistInfo?.map((listFetch, index) => (
                        <option
                        key={listFetch?._id}

                          value={`${listFetch?._id}_${listFetch?.stateName}`}
                        >
                          {listFetch?.stateName}
                        </option>
                      ))}
                  
                </select>
                <p className="text-red">{errors.state?.message}</p>
              </div> 
              <div className="col-md-3  tank-col-info">
                    <label
                      htmlFor="district"
                      className="text-gray text-semi-bold"
                    >
                      District<span className="text-red">*</span>
                    </label>

                    <select
                      id="district"
                      {...register("district", {
                        required: {
                          value: true,
                          message: "District Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select District"
                      onChange={(e) => handleLocation(e)}
                      
                    >
                      <option value="">Select District</option>
                      {districtData?.map((listFetch, index) => (
                        <option
                          value={`${listFetch?.id}_${listFetch?.districtName}`}
                          selected ={`${locationData[0]?.districtId}` === `${listFetch?.id}`}

                        >
                          {listFetch?.districtName}
                        </option>
                      ))}
                    </select>

                    <p className="text-red">{errors.district?.message}</p>
                  </div>
              
              {
                locationFlag === true?<>
                <div className="col-md-3 ">
              <label htmlFor="location" className="text-gray text-semi-bold">
                 Location <span className="text-red">*</span>
                </label>
              <select
                  id="location"
                  {...register("location", {
                    required: {
                      value: true,
                      message: "Location field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Location"
                  onChange={(e) => setExpSlotOnlineOfflineData([])}
                >
                  <option value="">Select Location</option>
                  {locationData?.[0]?.success && locationData?.[0]?.data?.map((fetchRow, index) => (
                    <option value={`${fetchRow?._id}_${fetchRow?.locationName}`}>
                     {fetchRow?.locationName}
                    </option>
                  ))}
                </select>
                <p className="text-red">{errors.location?.message}</p>
              </div>
                </>:<></>
              }
              
              <div className="col-md-3  tank-col-info">
                <label
                  htmlFor="slotStartDate"
                  className="text-gray text-semi-bold"
                >
                  Slot Start Date<span className="text-red">*</span>
                </label>
                {/* <input
                  id="slotStartDate"
                  {...register("slotStartDate", {
                    required: {
                      value: true,
                      message: "Enter Slot Start Date ",
                    },
                   

                  })}
                  disabled ={true}
                  type="date"
                  className="form-control  mb-15"
                /> */}
                 <input
                      id="slotStartDate"
                      {...register("slotStartDate", {
                        required: { value: true, message: "Enter Slot Start Date" },
                        validate: (value) => {
                          const slotEndDate = new Date(getValues("slotEndDate"));
                          const slotStartDate = new Date(value);
                          const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (slotStartDate < today) {
        return "Slot Start Date cannot be in the past";
      }
    
      if (getValues("slotEndDate") && slotStartDate >= slotEndDate) {
        return "Slot Start Date must be earlier than Slot End Date";
      }
    
      return true;
    
                    
                          // return (
                          //   !getValues("slotEndDate") ||
                          //   slotStartDate < slotEndDate ||
                          //   slotStartDate < today ||
                          //   "Slot Start Date must be earlier than Slot End Date"
                          // );
                        },
                      })}
                      type="date"
                      className="form-control rounded-10 mb-15"
                      placeholder="Slot End Date"
                      title="select End date"
                    />
                <p className="text-red">{errors.slotStartDate?.message}</p>
              </div>
              <div className="col-md-3  tank-col-info">
                <label
                  htmlFor="slotEndDate"
                  className="text-gray text-semi-bold"
                >
                  Slot End Date<span className="text-red">*</span>
                </label>
                {/* <input
                  id="slotEndDate"
                  min={moment().add(1, 'day').format('YYYY-MM-DD')}
                  {...register("slotEndDate", {
                      required: {
                      value: true,
                      message: "Enter Slot End Date",
                    },
                    validate: value => {
                      const selected = new Date(value);
                      const today = new Date();
                
                      // Ignore time for clean comparison
                      selected.setHours(0, 0, 0, 0);
                      today.setHours(0, 0, 0, 0);
                
                      return selected > today || "Date must be after today";
                    },
                  })}
                  onChange={(e) => setExpSlotOnlineOfflineData([])}
                  type="date"
                  className="form-control  mb-15"
                 /> */}

<input
                      id="slotEndDate"
                      {...register("slotEndDate", {
                        required: { value: true, message: "Enter End Date" },
                        validate: (value) => {
                          const slotStartDate = new Date(getValues("slotStartDate"));
                          const slotEndDate = new Date(value);
                    
                          return (
                            !getValues("slotStartDate") ||
                            slotEndDate > slotStartDate ||
                            "End Date must be after Start Date"
                          );
                        },
                      })}
                      type="date"
                      className="form-control rounded-10"
                      placeholder="End Date"
                      title="select End date"
                    />
                <p className="text-red">{errors.slotEndDate?.message}</p>
              </div>
              

              <div className="col-md-3 text-left mt-20">
                <input
                  type="submit"
                  className="btn btn-sm btn-secondary rounded-20"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>
        <hr className="mt-20 mb-20" />

        {expSlotOnlineOfflineData.length > 0 ? (
          <>
            <div className="row " >
              {[
                "Morning Shift",
                "Afternoon Shift",
                "Evening Shift",
                "Night Shift",
              ]?.map((fetchShiftRow, index) =>
                shiftData?.[0]?.ShiftData?.map((fetchRow, index) =>
                  fetchShiftRow == fetchRow?.shiftName ? (
                    <>
                      <div
                        className="col-md-3  tank-col-info text-center"
                        onClick={(e) => handleClick(fetchRow?.shiftName)}
                      >
                        <label
                          htmlFor=""
                          className={
                            shiftFlag === fetchRow?.shiftName
                              ? " btn-no-outline-green cursor"
                              : "text-black  btn-no-outline-gray cursor"
                          }
                        >
                          {fetchRow?.shiftName == "Morning Shift" ? (
                            <WiSunrise />
                          ) : fetchRow?.shiftName == "Evening Shift" ? (
                            <WiSunset />
                          ) : fetchRow?.shiftName == "Afternoon Shift" ? (
                            <PiClockAfternoonThin />
                          ) : fetchRow?.shiftName == "Night Shift" ? (
                            <MdOutlineNightlight />
                          ) : (
                            ""
                          )}
                          {fetchRow?.shiftName} <br />
                          {/* <span className="text-gray">{`${fetchRow?.shiftStartTime} - ${fetchRow?.shiftEndTime}`}</span>
                          <br /> */}
                          {/* <span className="text-gray">
                            {`${fetchRow?.slotTime} min/slot`}{" "}
                          </span> */}
                        </label>
                      </div>
                    </>
                  ) : (
                    <></>
                  )
                )
              )}
            </div>
            <hr className="mt-20 mb-20" />
           
            {
            expSlotOnlineOfflineData?.map((fetchRows, gindex) => (
              <>
                <div className="row">
                  <div className="col-md-2  tank-col-info text-center">
                    <div className="btn btn-no-outline-gray rounded-5 btn-wrapper">
                      <input
                        type="checkbox"
                        className="mr-10"
                         id={`${fetchRows?._id}_${gindex}`}
                        title="select all"
                         checked = {fetchRows?.[`${currentSlot}Flag`] == "true"?true:false}
                        onClick={() =>
                          handleSlotAllStatus(
                            fetchRows?._id,
                            fetchRows?.[`${currentSlot}Flag`],
                            currentSlot,
                            expAvailDateIdMap?.[ fetchRows?.slotDate ]

                          )
                        }
                      />
                      {/* <label htmlFor={`${fetchRows?._id}_${gindex}`}> */}
                      <label >
                        {" "}
                        {moment(fetchRows?.slotDate).format("DD MMMM YYYY")}

                      </label>
                    </div>
                  </div>
                  <div className="col-md-10  tank-col-info text-left">
                    <span className="text-black text-bold ml-5">
                      {fetchRows?.[currentSlot]?.map((fetchSlot, index) => (
                        <>
                        {
                          ((fetchSlot?.expertModeId && fetchSlot?.expertModeId == expAvailDateIdMap[fetchRows?.slotDate ] ) || ((fetchSlot?.status =='V') && (fetchSlot?.expertModeId == "")))?<>
                          {/* <span className="ml-5"> */}

<input
                            type="checkbox"
                            checked={
                              (fetchSlot?.status == "A" ||
                              fetchSlot?.status == "B")
                                ? true
                                : fetchSlot?.status == "V"
                                ? false
                                : false
                            }
                            title={fetchSlot?.time}
                            id={`${fetchRows?._id}_${index}`}
                            name={`${fetchRows?._id}_${index}`}
                            disabled={(fetchSlot?.status  == "B" && user?.usertype=="expert") ? true : false}
                            hidden = {true}
                            onClick={() =>
                              handleSlotStatus(
                                fetchRows?._id,
                                currentSlot,
                                fetchSlot?._id,
                                fetchSlot?.status,
                                expAvailDateIdMap?.[ fetchRows?.slotDate ]

                                
                              )
                            }
                          />
                          <button
                            className={`btn-slot  ${fetchSlot?.status == "V"?"btn-outline-blue-hov":fetchSlot?.status == "A"?"btn-outline-green":fetchSlot?.status == "B"?"btn-outline-red":fetchSlot?.status == "H"?"btn-outline-gray":""}  rounded-10 mr-5 ml-5 mt-10 mb-10 p-5`}
                              title={`${fetchSlot?.status == "V"?"Click to Book Now":fetchSlot?.status == "A"?"Click to Vacant Now ":fetchSlot?.status == "B"?"Slot Booked By User":""}`}
                              disabled={(fetchSlot?.status == "B" && user?.usertype=="expert") ? true : false}
                                 onClick={() =>
                              handleSlotStatus(
                                fetchRows?._id,
                                currentSlot,
                                fetchSlot?._id,
                                fetchSlot?.status,
                                expAvailDateIdMap?.[ fetchRows?.slotDate ]
                                

                              )
                            }
                          >
                            {/* <label htmlFor={`${fetchRows?._id}_${index}`}> */}
                            {/* <label > */}
                              {fetchSlot?.time}
                            {/* </label> */}
                          </button>
                          {/* </span> */}
                          
                          </>:
                          ((fetchSlot?.expertModeId && fetchSlot?.expertModeId != expAvailDateIdMap[fetchRows?.slotDate ]))?<>
                           <button
                            className={`btn-slot  btn-outline-gray  rounded-10 mr-5 ml-5 mt-10 mb-10 p-5`}
title="Booked By Other Mode"
                           
                          >
                            {/* <label htmlFor={`${fetchRows?._id}_${index}`}> */}
                            {/* <label > */}
                              {fetchSlot?.time}
                            {/* </label> */}
                          </button>
                          </>:<></>
                        }




                          



                        </>
                      ))}
                    </span>
                  </div>
                </div>
                <hr className="mt-20 mb-20" />
              </>
            ))
            }
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default ExpertAvailability;
